export default __webpack_public_path__ + "static/media/mobileEnvImage.9aadd021.png";